import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[560px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20Korean%20manhwa%20style%20illustration%2C%20cozy%20reading%20nook%20with%20soft%20golden%20light%2C%20bookshelves%20with%20colorful%20comic%20books%2C%20gentle%20sunlight%20streaming%20through%20window%2C%20peaceful%20and%20inviting%20mood%2C%20warm%20amber%20and%20cream%20tones%2C%20digital%20art%20with%20painterly%20texture&width=1600&height=800&seq=cta-bg-manhwa&orientation=landscape"
          alt="虚空韩漫网 - 开始阅读"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 text-center px-4 max-w-2xl mx-auto">
        <h2 className="font-heading text-3xl md:text-5xl text-background-50 leading-tight mb-4">
          准备好探索<br />韩漫世界了吗？
        </h2>
        <p className="text-background-300/90 text-sm md:text-base mb-8 leading-relaxed">
          八千余部韩漫作品，每日实时更新<br />
          无需注册，完全免费，即刻畅享无删减阅读体验
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3.5 rounded-full bg-background-950/90 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-background-950 transition-colors cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-book-open-line text-base"></i>
            立即开始阅读
          </Link>
          <Link
            to="/category/latest"
            className="px-8 py-3.5 rounded-full border border-background-400/60 text-background-200 text-sm font-medium whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-fire-line text-base"></i>
            查看最新更新
          </Link>
        </div>
      </div>
    </section>
  );
}